module.exports = __webpack_public_path__ + "img/banner-thumbnail.f7192371.png";